export default "__VITE_ASSET__CZ3uB2$q__"